<template>
    <div>
        <app-bar
                :backTo="back_to"
                hideMenu
        >
            <template v-slot:action>
                <v-btn icon @click="getNotification">
                    <v-icon size="30">mdi-reload</v-icon>
                </v-btn>
            </template>

        </app-bar>

        <loader noSpace numb="8" v-if="loading"></loader>
        <v-list no-gutters class="pa-0 ma-0" v-else>

            <v-subheader>Notifiche</v-subheader>

            <template>
                <v-list-item v-for="(item, index) in notifications" :key="item.index" dense :class="notificationClass(item)">
                    <template v-slot:default="{ active }">

                        <v-btn icon outlined x-small @click="dismiss(item)" class="mr-4">
                            <v-icon>mdi-delete</v-icon>
                        </v-btn>

                        <v-list-item-content>
                            <p class="body-2">
                                <strong>{{item.title}}</strong>
                            </p>

                            <p class="body-2">
                                {{item.message}}
                            </p>
                        </v-list-item-content>

                        <v-list-item-action>
                            <v-list-item-action-text v-text="item.timeago"></v-list-item-action-text>
                        </v-list-item-action>

                    </template>
                </v-list-item>

                <v-divider
                        v-if="index < notifications.length - 1"
                        :key="index"
                ></v-divider>
            </template>
        </v-list>

        <div v-if="!allLoaded" class="text-center my-3">
            <v-btn v-intersect="{
                                    handler: loadMore,
                                    options: {
                                       rootMargin:'0px 0px -100px 0px',
                                       threshold: [0.75]
                                    }
                                  }"
                   fab small loading>
            </v-btn>
        </div>

        <div class="text-center" v-if="allLoaded">
            <v-icon class="d-block rem4" color="white">mdi-check</v-icon>
            <span>Non hai nuove notifiche da leggere!</span>
        </div>

    </div>
</template>

<script>
    import axios from 'axios';
    import {mapMutations, mapActions, mapGetters} from 'vuex'
    import TimeAgo from 'javascript-time-ago'
    import it from 'javascript-time-ago/locale/it'

    TimeAgo.addDefaultLocale(it);

    export default {
        name: "notifications",
        props: {
            back_to: Object,
        },
        data() {
            return {
                loading: true,
                timeAgo: new TimeAgo('it-IT'),
                appMenu: [
                    {text: 'Aggiungi al Menù', icon: 'mdi-pin', action: 'addToMenu'},
                ],
                memberId: false,
                clubId: false,
                notifications: [],
                limit: 10,
                allLoaded: false,
                loadingMoreData: false
            }
        },
        mounted() {
            this.memberId = this.getMemberID;
            this.clubId = this.getMainClubID;
            setTimeout(() => {
                this.getNotification();
            }, 100);
            setTimeout(() => {
                this.setRead();
            }, 300);
        },
        computed: {
            ...mapGetters([
                'getMainClubID',
                'getMemberID',
            ]),
        },
        methods: {
            notificationClass(notification) {
                let result = [];
                if (notification.read_timestamp != null) {
                    result.push('readed');
                }
                if (notification.container_id === this.getMainClubID) {
                    result.push('club_notif');
                }
                return result;
            },
            ...mapMutations([
                'setLoading',
                'setUnreadNotify'
            ]),
            ...mapActions([
                '_addToMenu'
            ]),
            getNotification() {
                this.loading = true;
                if (this.allLoaded) {
                    setTimeout(() => {
                        this.loading = false;
                    }, 300);
                    return;
                }
                let data = {
                    memberId: this.memberId,
                    clubId: this.clubId,
                    offset: this.notifications.length,
                    limit: this.limit
                };
                axios
                    .post(this.$store.state.ROOT_API + '/notifications/get', data,
                        {
                            headers: {
                                'Authorization': 'Bearer ' + this.$store.getters.getToken
                            }
                        })
                    .then(resp => {
                        this.loading = false;
                        if (resp.data.length === 0) {
                            this.allLoaded = true;
                        }
                        if (resp.data.length > 0) {
                            //console.log('da server:',resp.data)
                            this.notifications.push.apply(this.notifications, resp.data);
                            this.notifications.forEach(item => {
                                item.timeago = this.timeAgo.format(new Date(item.created_at))
                            });
                            //console.log('notifiche totali:',this.notifications)
                        }
                    })
                    .catch((error) => {
                        console.error(error)
                    });
            },
            loadMore(entries, observer, isIntersecting) {
                this.loadingMoreData = isIntersecting;
                if (isIntersecting && this.loadingMoreData) {
                    if (this.notifications.length) {
                        this.getNotification();
                    }
                }
            },
            setRead() {
                this.notifyStatus = false; //TODO non funziona....

                let containerIds = [this.memberId];
                if (this.clubId) {
                    containerIds.push(this.clubId);
                }
                axios
                    .post(this.$store.state.ROOT_API + '/notifications/read', {containerIds: containerIds},
                        {
                            headers: {
                                'Authorization': 'Bearer ' + this.$store.getters.getToken
                            }
                        })
                    .then(resp => {
                        this.notifications.forEach(i => {
                            i.read_timestamp = new Date().toLocaleDateString();
                            this.notificationClass(i);
                        });
                        this.setUnreadNotify(false);
                    })
                    .catch((error) => {
                        console.error(error)
                    });
            },
            dismiss(notification) {
                axios
                    .post(this.$store.state.ROOT_API + '/notifications/dismiss', {
                            notificationId: notification.id,
                            containerId: notification.container_id
                        },
                        {
                            headers: {
                                'Authorization': 'Bearer ' + this.$store.getters.getToken
                            }
                        })
                    .then(resp => {
                        this.notifications.splice(this.notifications.indexOf(notification), 1);
                    })
                    .catch((error) => {
                        console.error(error)
                    });
            },
        }
    }
</script>

<style scoped>
    .v-list {
        padding: 0 !important;
    }

    .v-list-item {
        background-color: #FBE9E7;
        border-left: solid 5px #fff !important;
    }

    .readed {
        background-color: #ffffff;
    }

    .readed .body-2 {
        color: #999;
    }

    .club_notif {
        border-color: darkred !important;
    }
</style>